/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AppointmentsInputs */

const en__field_appointments = /** @type {(inputs: _Field_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointments`)
};

const de__field_appointments = /** @type {(inputs: _Field_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

/**
* | output |
* | --- |
* | "Appointments" |
*
* @param {_Field_AppointmentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_appointments = /** @type {((inputs?: _Field_AppointmentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AppointmentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_appointments(inputs)
	return de__field_appointments(inputs)
});